import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import Reveal from '@/components/base/Reveal';

const phases = [
  { name: '投稿提交', desc: '选手提交作品与来源说明', state: 'done' },
  { name: '编辑复核', desc: '核对来源层级与表述规范', state: 'active' },
  { name: '进入合集', desc: '公开收录并计入热度榜', state: 'todo' },
];

export default function SeasonOverview() {
  const { season } = siteInfo;
  const progress = [
    { label: '已投稿', value: season.submitted, ratio: 1 },
    { label: '已复核', value: season.reviewed, ratio: season.reviewed / season.submitted },
    { label: '已公开', value: season.published, ratio: season.published / season.submitted },
  ];

  return (
    <section className="w-full border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-2 lg:gap-14">
        <Reveal>
          <span className="font-label text-xs tracking-[0.2em] text-primary-600">{season.name} 赛季进度</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            从投稿到进入合集，每篇作品都走完这三步
          </h2>
          <p className="mt-4 max-w-xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            黑料大赛不是一次性放榜，而是一个持续运转的作品池。投稿先进初审队列，编辑核对来源后进入复核，
            通过复核才会计入作品合集与热门作品榜。整个过程对选手可见，也方便读者判断一篇作品的可信程度。
          </p>

          <ol className="mt-8 flex flex-col gap-5">
            {phases.map((phase, index) => (
              <li key={phase.name} className="flex gap-4">
                <div className="flex flex-col items-center">
                  <span
                    className={`flex h-8 w-8 items-center justify-center rounded-full font-label text-xs ${
                      phase.state === 'done'
                        ? 'bg-secondary-500 text-background-50'
                        : phase.state === 'active'
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {index + 1}
                  </span>
                  {index < phases.length - 1 && <span className="mt-1 h-8 w-px bg-background-300"></span>}
                </div>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{phase.name}</h3>
                  <p className="mt-1 font-body text-sm text-foreground-600">{phase.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-1.5 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            了解收录标准与内容原则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </Reveal>

        <Reveal delay={120}>
          <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold text-foreground-950">本赛季数据看板</h3>
              <span className="flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
                <i className="ri-pulse-line"></i>
                {season.phase}
              </span>
            </div>

            <div className="mt-6 flex flex-col gap-6">
              {progress.map((row) => (
                <div key={row.label}>
                  <div className="flex items-end justify-between font-label text-sm">
                    <span className="text-foreground-700">{row.label}</span>
                    <span className="font-heading text-lg font-bold text-foreground-950">
                      {row.value.toLocaleString('zh-CN')}
                    </span>
                  </div>
                  <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-primary-500 transition-all duration-700"
                      style={{ width: `${Math.round(row.ratio * 100)}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4 border-t border-background-200 pt-6">
              <div>
                <p className="font-label text-xs text-foreground-500">赛季开始</p>
                <p className="mt-1 font-heading text-base font-bold text-foreground-950">{season.startDate}</p>
              </div>
              <div>
                <p className="font-label text-xs text-foreground-500">征集截止</p>
                <p className="mt-1 font-heading text-base font-bold text-primary-600">{season.endDate}</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}